import {
  CreateThirdPartyBillingAccountSchema,
  ThirdPartyBillingAccountSchema,
} from "@redotech/redo-model/outbound-labels/third-party-billing-accounts";
import * as z from "zod/v4";

export const createThirdPartyBillingAccount = {
  name: "createThirdPartyBillingAccount" as const,
  input: CreateThirdPartyBillingAccountSchema.omit({ team: true }),
  output: z.object({ account: ThirdPartyBillingAccountSchema }),
};
